import React from "react";
import ShowcaseDashboard from "../components/dashboard/ShowcaseDashboard";

const ShowcaseDashboardPage: React.FC = () => {
  return <ShowcaseDashboard />;
};

export default ShowcaseDashboardPage;
